import { ChevronRight } from "lucide-react";
import { mainButtons } from "@/data/site";
import { WhatsAppIcon, InstagramIcon } from "./icons";

const iconMap = {
    whatsapp: WhatsAppIcon,
    instagram: InstagramIcon,
};

const iconWrapper = {
    whatsapp: "bg-[#25D366]/10 text-[#128C7E]",
    instagram:
        "bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white",
};

export default function LinkButtons() {
    return (
        <section
            data-testid="main-buttons"
            className="wx-container mt-6 flex flex-col gap-3"
        >
            {mainButtons.map((b) => {
                const Icon = iconMap[b.icon];
                return (
                    <a
                        key={b.id}
                        href={b.url}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={`main-btn-${b.id}`}
                        className="wx-link-row group"
                    >
                        <span
                            className={`inline-flex items-center justify-center w-10 h-10 rounded-xl ${iconWrapper[b.icon]}`}
                        >
                            <Icon className="w-5 h-5" />
                        </span>
                        <span className="flex-1 text-[15px] font-semibold text-[color:var(--wx-ink)] tracking-tight">
                            {b.label}
                        </span>
                        <ChevronRight className="w-4 h-4 text-[color:var(--wx-muted)] group-hover:text-[color:var(--wx-blue)] transition" />
                    </a>
                );
            })}
        </section>
    );
}
